import styled from "styled-components"

export const ReplyFormWrapper = styled.div`
    .form_reply{
        input{
            flex: 1;
            height: 40px;
            border-radius: 4px 0px 0px 4px;
        }
        button{
            width: 40px;
            height: 40px;
            background-color: #2f80ed;
            border-radius: 0 4px 4px 0;
        }
    }
`
